// extracted by mini-css-extract-plugin
module.exports = {"pageProduct":"NA_pageProduct__2s1ah"};